module.exports = __webpack_public_path__ + "img/mediaplayer.27067300.png";